import { Menu, MenuItem } from '@mui/material'
import { KeyboardArrowDown } from '@mui/icons-material'

import { useSelector } from '@tabeeb/store'
import { IconButton, usePopoverState } from '@collaborate-health/uikit'

import { getContentFormsForCurrentUser } from '../../selectors'

export interface FormsNavigationMenuProps {
  selectedFormId?: number | null
  onSelectForm: (formId: number) => void
}

const FormsNavigationMenu: React.FC<FormsNavigationMenuProps> = ({ selectedFormId, onSelectForm }) => {
  const forms = useSelector(getContentFormsForCurrentUser)

  const [anchorRef, open, onOpen, onClose] = usePopoverState<HTMLButtonElement>()

  return (
    <>
      <IconButton ref={anchorRef} size='small' onClick={onOpen}>
        <KeyboardArrowDown />
      </IconButton>
      <Menu
        open={open}
        onClose={onClose}
        anchorEl={anchorRef.current}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{
          paper: { sx: { maxWidth: 400, maxHeight: 420 } },
        }}
      >
        {forms.map((form) => (
          <MenuItem
            key={form.Id}
            selected={form.Id === selectedFormId}
            title={form.Name!}
            onClick={() => {
              onSelectForm(form.Id)
              onClose()
            }}
          >
            {form.Name}
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}

export default FormsNavigationMenu

